export function getProspectList(){
    return async function (dispatch){ // resume list of all clients
        dispatch({
            type: "FETCH_PROSPECT_START",
            payload: ""  
        })

        try {
            const response = await fetch('/user/prospect?nb=1&id=1&type=Prospect', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                console.log('[ERROR], getting prospect response ',resp);
                dispatch({
                    type: "FETCH_PROSPECT_ERROR",
                    payload: resp.msg  
                })
                return;
            }
            console.log('PROSPECT LIST : ', resp);
            
            let prospectList = {}
            resp.contentArray.map( (item, index) => {
                let userInfo = {}
                for (let i = 0; i < item.length && i < 10; i++){
                    
                    userInfo[resp.contentHeader[i]] = item[i]
                    
                }
                userInfo.ID = resp.userID[index];
                userInfo.boxAssoId = resp.userID[index];
                prospectList[resp.userID[index]] = userInfo
            })
            dispatch({
                type: "GET_RESUME_PROSPECTS",
                payload: prospectList
                
            })
            dispatch({ type: "FETCH_PROSPECT_FULFILLED", payload:"" })

            
        } catch (err) {
            console.log("[ERROR], getting prospect data",err)
            dispatch({
                type: "FETCH_PROSPECT_ERROR",
                payload: err  
            })
        }
    }
    
}

export function fetchProspectsType(pType) {
    return async function(dispatch){
        dispatch({
            type: "FETCH_PROSPECT_TYPE_START",
            payload: ""  
        })
        try {
            const response = await fetch(`/user/prospect?nb=1&id=1&type=${pType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();

            if (resp.msg != "OK" ){
                console.log('[ERROR], getting prospect response ',resp);
                dispatch({
                    type: "FETCH_PROSPECT_TYPE_ERROR",
                    payload: resp.msg  
                })
                return;
            }
            let prospectList = {}
            resp.contentArray.map( (item, index) => {
                let userInfo = {}
                for (let i = 0; i < item.length && i < 10; i++){
                    userInfo[resp.contentHeader[i]] = item[i]
                }
                userInfo.ID = resp.userID[index];
                userInfo.boxAssoId = resp.userID[index];
                prospectList[resp.userID[index]] = userInfo
            })

            dispatch({
                type: "GET_PROSPECTS_TYPE",
                payload: {list: prospectList, headers: resp.contentHeader, pType: pType }
                
            })
            dispatch({ type: "FETCH_PROSPECT_TYPE_FULFILLED", payload:"" })
        } catch (err) {
            console.log("[ERROR], getting prospect data",err)
            dispatch({
                type: "FETCH_PROSPECT_TYPE_ERROR",
                payload: err  
            })
        }
    }
}